import { Box, Flex } from "@chakra-ui/react";
import { Navigate, useSearchParams } from "react-router-dom";
import { urls } from "../../urls";
import { WORK_AREA_BLEED, WORK_AREA_PADDING } from "../layout/workAreaPadding";
import { useSub } from "../subscription/useSub";
import { AssistantChat } from "./AssistantChat";
import { CONVERSATION_LIST_BREAKPOINT, ConversationList } from "./ConversationList";
import { CreateProcurementWithAi } from "./CreateProcurementWithAi";
import { CREATES_PROCUREMENT_PARAM, CREATES_PROCUREMENT_VALUE, PROJECT_PARAM } from "./createProcurementParams";

export const AssistantPage = () => {
  const { canUseAssistant } = useSub();
  const [params] = useSearchParams();
  if (!canUseAssistant) {
    return <Navigate to={urls.app.home} replace />;
  }
  if (params.get(CREATES_PROCUREMENT_PARAM) === CREATES_PROCUREMENT_VALUE) {
    return (
      <Box {...WORK_AREA_BLEED} p={WORK_AREA_PADDING} bg="smBackground" data-testid="assistant-conversation-area">
        <CreateProcurementWithAi projectId={params.get(PROJECT_PARAM)} />
      </Box>
    );
  }
  return (
    <Flex {...WORK_AREA_BLEED}>
      <Box display={{ base: "none", [CONVERSATION_LIST_BREAKPOINT]: "block" }} h="full">
        <ConversationList />
      </Box>
      <Box flex="1" minW="0" h="full" p={WORK_AREA_PADDING} bg="smBackground" data-testid="assistant-conversation-area">
        <AssistantChat conversationsListedBeside />
      </Box>
    </Flex>
  );
};

